module.exports = __webpack_public_path__ + "img/icon-circle-alert-red.92faeacf.svg";